module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Pridel Document")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReportsReverse('Document_Validator_LIST_EXCEL')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n          "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v("Pridel Document")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n                    Document Type\n                    "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "col-9"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.All_Document_TypeList,
      "option-value": "documentTypeId",
      "option-text": "documentName",
      "placeholder": "Select Document Type"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.fk_doc_type_id),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "fk_doc_type_id", $$v)
      },
      expression: "DocumentValidatorMaster.fk_doc_type_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openDocumentValidatorModal()
      }
    }
  }, [_vm._v("Add")])], 1)]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "md": "12"
    }
  }, [(!_vm.DocumentValidatorMaster.fk_doc_type_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.errorList.fk_doc_type_id) + "\n                  ")]) : _vm._e()])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Document Number\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": (_vm.DocumentValidatorMaster.documentvalidatorId > 0 || _vm.DocumentValidatorMaster.EmailSentStatus == 0) ? true : false,
      "formatter": _vm.capitalizeAll,
      "id": "documentNumber",
      "name": "documentNumber",
      "placeholder": "Please Enter documentNumber",
      "type": "text"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentNumber),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentNumber", $$v)
      },
      expression: "DocumentValidatorMaster.documentNumber"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentNumber) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Document Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "documentName",
      "name": "documentName",
      "placeholder": "Document Name"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentName),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentName", $$v)
      },
      expression: "DocumentValidatorMaster.documentName"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentName) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Document Issue Date\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "width": "100%",
      "type": "date",
      "id": "documentIssueDate",
      "placeholder": "Document Issue Date"
    },
    on: {
      "change": function($event) {
        _vm.EndDateSelect(_vm.DocumentValidatorMaster.documentIssueDate, _vm.DocumentValidatorMaster.EmailSentStatus)
      }
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentIssueDate),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentIssueDate", $$v)
      },
      expression: "DocumentValidatorMaster.documentIssueDate"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentIssueDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentIssueDate) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Document End Date\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "documentEndDate",
      "name": "documentEndDate",
      "placeholder": "Document End Date"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentEndDate),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentEndDate", $$v)
      },
      expression: "DocumentValidatorMaster.documentEndDate"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentEndDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentEndDate) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Document Reminder Date\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "width": "100%",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "documentRemainderDate",
      "name": "documentRemainderDate",
      "placeholder": "Document Reminder Date"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentRemainderDate),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentRemainderDate", $$v)
      },
      expression: "DocumentValidatorMaster.documentRemainderDate"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentRemainderDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentRemainderDate) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status :")]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.DocumentValidatorMaster.isDocumentActive,
      "name": "approval",
      "value": _vm.DocumentValidatorMaster.isDocumentActive == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activateDocumentValidatorMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.DocumentValidatorMaster.isDocumentActive == 1 ?
        'success' :
        'danger'
    }
  }, [_vm._v(_vm._s(_vm.DocumentValidatorMaster.isDocumentActive == 1 ?
    "Active" :
    "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Email TO\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ToEmail",
      "name": "ToEmail",
      "placeholder": "Email TO"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.ToEmail),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "ToEmail", $$v)
      },
      expression: "DocumentValidatorMaster.ToEmail"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.ToEmail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.ToEmail) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Email CC\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "CCEmail",
      "name": "CCEmail",
      "placeholder": "Email CC"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.CCEmail),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "CCEmail", $$v)
      },
      expression: "DocumentValidatorMaster.CCEmail"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.CCEmail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.CCEmail) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("\n                  Document File\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-file-uploader', {
    style: ('height: 80px; background: darkgray; width: 100%'),
    attrs: {
      "documentName": 'pridel_validated_doc',
      "otherDocName": 'pridel_validated_doc',
      "folderName": 'pridel_validated_doc',
      "accept": '*',
      "assign_no": 'pridel_validated_doc',
      "multiple": true,
      "state": Boolean(_vm.DocumentValidatorMaster.documentFileName),
      "fileAllModuleId": _vm.DocumentValidatorMaster.documentvalidatorId
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentFileName),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentFileName", $$v)
      },
      expression: "DocumentValidatorMaster.documentFileName"
    }
  }), _vm._v(" "), (!_vm.DocumentValidatorMaster.documentFileName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentFileName) + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.DocumentValidatorMaster.documentFileName != '' &&
    _vm.DocumentValidatorMaster.documentFileName != undefined &&
    _vm.DocumentValidatorMaster.documentFileName != null
  ) ? _c('b', _vm._l((_vm.DocumentValidatorMaster.documentFileName.split(',')), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [(item_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.PrintValidity_Doc(item_doc)
        }
      }
    }, [_vm._v("View Doc -\n                      " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Document Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "documentRemarks",
      "name": "documentRemarks"
    },
    model: {
      value: (_vm.DocumentValidatorMaster.documentRemarks),
      callback: function($$v) {
        _vm.$set(_vm.DocumentValidatorMaster, "documentRemarks", $$v)
      },
      expression: "DocumentValidatorMaster.documentRemarks"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addDocumentValidatorMaster
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.DocumentValidatorMaster.EmailSentStatus == 1 ? "Renewal" : (
    _vm.DocumentValidatorMaster.documentvalidatorId ? "Update" : "Save")) + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "DocumentType-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add DocumentType"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Document Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "documentName",
      "name": "documentName"
    },
    model: {
      value: (_vm.DocumentTypeModal.documentName),
      callback: function($$v) {
        _vm.$set(_vm.DocumentTypeModal, "documentName", $$v)
      },
      expression: "DocumentTypeModal.documentName"
    }
  }), _vm._v(" "), (!_vm.DocumentTypeModal.documentName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.DocumenterrorList.documentName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Description ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "description",
      "name": "description"
    },
    model: {
      value: (_vm.DocumentTypeModal.description),
      callback: function($$v) {
        _vm.$set(_vm.DocumentTypeModal, "description", $$v)
      },
      expression: "DocumentTypeModal.description"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addDocumentType
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideDocumentType
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "DocumentList-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "All Pridel Document List"
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Pridel_Document_data,
      "responsive": "",
      "fields": _vm.HistoryColumns,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "pri_docId",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                ")])]
      }
    }, {
      key: "Username",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.Username != "" ? row1.item.Username : "--"))])]
      }
    }, {
      key: "documentName",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.documentName != "" ? row2.item.documentName : "--"))])]
      }
    }, {
      key: "pri_docName",
      fn: function(row3) {
        return [(_vm.doc_item != '') ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px",
            "margin-bottom": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.PrintValidity_Doc(row3.item.pri_docName)
            }
          }
        }, [_vm._v("View Doc ")]) : _vm._e()]
      }
    }, {
      key: "startDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.startDate != "" ? row4.item.startDate : "--"))])]
      }
    }, {
      key: "EndDate",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.EndDate != "" ? row5.item.EndDate : "--"))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Charges Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Document_Validator_List_data,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "common_over_id",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "idmasterChargers",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "priDocNumber",
      fn: function(row9) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row9.item.priDocNumber !=
          "" ? row9.item.priDocNumber : "--") + "\n                  ")])]
      }
    }, {
      key: "documentTypeName",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.documentTypeName != "" ? row1.item.documentTypeName : "--"))])]
      }
    }, {
      key: "documentName",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.documentName != "" ? row2.item.documentName : "--"))])]
      }
    }, {
      key: "documentIssueDate",
      fn: function(row3) {
        return [_c('span', [_c('b', [_vm._v("Issue Date ")]), _vm._v(_vm._s(_vm._f("moment")(row3.item.documentIssueDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Reminder Date ")]), _vm._v(_vm._s(_vm._f("moment")(row3.item.documentRemainderDate)))])]
      }
    }, {
      key: "documentEndDate",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row4.item.documentEndDate)))]), _c('br')]
      }
    }, {
      key: "ToEmail",
      fn: function(row5) {
        return [_c('span', [_vm._v(" Email TO: "), _c('b', [_vm._v(_vm._s(row5.item.ToEmail))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" Email CC: "), _c('b', [_vm._v(_vm._s(row5.item.CCEmail))])])]
      }
    }, {
      key: "documentFileName",
      fn: function(row7) {
        return _vm._l((row7.item.documentFileName.split(',')), function(doc_item, doc_index) {
          return _c('span', {
            key: doc_index
          }, [(doc_item != '') ? _c('b-button', {
            staticStyle: {
              "margin-left": "2px",
              "margin-bottom": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.PrintValidity_Doc(doc_item)
              }
            }
          }, [_vm._v("View Doc " + _vm._s(doc_index + 1) + "\n                    ")]) : _vm._e()], 1)
        })
      }
    }, {
      key: "isDocumentActive",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.documentvalidatorId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.documentvalidatorId,
            "name": "approval",
            "value": row22.item.isDocumentActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateDocumentValidator(row22.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.isDocumentActive == 1 ? 'Active' : 'In-Active'))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.documentvalidatorId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.expiry_flag))])], 1)])]
      }
    }, {
      key: "action",
      fn: function(row6) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editDocumentValidatorMaster(row6.item)
            }
          }
        }, [_vm._v("Update\n                "), (_vm.isLoading) ? _c('CustomLoader', {
          attrs: {
            "width": 70
          }
        }) : _vm._e()], 1), _vm._v(" "), (
          row6.item.documentFileName != '' &&
          row6.item.documentFileName != null
        ) ? _c('b-button', {
          staticStyle: {
            "margin-left": "2px"
          },
          attrs: {
            "variant": "outline-success",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.openAllPridelDocumentListModal(row6.item)
            }
          }
        }, [_vm._v("History")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e806595e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/documentValidatorMaster.vue
// module id = 2896
// module chunks = 0